import React, { useState, useRef, useEffect } from 'react';
import style from './Dasboard_panel.module.css';
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import { API_BASE_URL } from '../../../Apiconfig';
import Add_Cart from '../add_cart/add_cart';


const DashboardNavbar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [name, setName] = useState('');
    const offcanvasRef = useRef(null);
    const offcanvasInstance = useRef(null);

    const handleLogout = async () => {
        try {
            localStorage.clear();
            await axios.post(`${API_BASE_URL}/logout.php`, {}, { withCredentials: true });
            navigate("/");
        } catch (error) {
            console.error("Logout failed:", error);
        }
    };

    const closeOffcanvas = () => {
        if (offcanvasInstance.current) {
            offcanvasInstance.current.hide();
        }
    };

    useEffect(() => {
        if (offcanvasRef.current) {
            offcanvasInstance.current = new window.bootstrap.Offcanvas(offcanvasRef.current, {
                backdrop: false,
            });

            const handleClickOutside = (event) => {
                if (offcanvasRef.current && !offcanvasRef.current.contains(event.target)) {
                    offcanvasInstance.current.hide();
                }
            };

            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }
    }, []);

    // Fetch name from localStorage once the component is mounted
    useEffect(() => {
        const storedName = localStorage.getItem('username');
        if (storedName) {
            setName(storedName);
        }
    }, []);

    // Map route paths to display names
    const routeNames = {
        "/Dashboard_panel/account_panel": "Account ",
        "/Dashboard_panel/customers_panel": "Customer ",
        "/Dashboard_panel/suppliers_panel": "Supplier ",
        "/Dashboard_panel/billing_panel": "Billing",
        "/Dashboard_panel/inventory_panel": "Inventory",
    };

    // Get the active route name
    const activeRoute = routeNames[location.pathname] || '';

    return (
        <>
            <div className={style.navbardashboard}>
                <nav className={`${style.navbar} navbar-sm`}>
                    <div className="container">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className={style.navdashleftside}>
                                <Link to={"/Dashboard_panel"} className={style.navheading}>   <img src="/images/logo.png" alt="" />
                                </Link>
                         
                                {activeRoute && <span className={style.activeRoute}>{activeRoute}</span>}
                            </div>

                            <div className={style.navright}>

                                <i className="fa-solid fa-bell"></i>
                                <div className='mx-3'><Add_Cart /></div>

                                <button
                                    className={style.sidebar_btn}
                                    type="button"
                                    data-bs-toggle="offcanvas"
                                    data-bs-target="#offcanvasExample"
                                >
                                    <i className="fa-solid fa-bars"></i>
                                </button>
                            </div>


                            {/* side bar code */}

                            <div
                                className={`offcanvas offcanvas-end ${style.offcanvassidebar} `}
                                tabIndex="-1"
                                id="offcanvasExample"
                                aria-labelledby="offcanvasExampleLabel"
                                ref={offcanvasRef}
                            >
                                {/* <div className={style.navSide}> */}

                                <div className="offcanvas-header">
                                    <div className={style.sideHeading}>
                                        <div className={style.navprofile}>
                                        <i class="fa-solid fa-user"></i> {name ? <span>{name}</span> : <span>Guest</span>}
                                        </div>
                                        {/* <h5 className="offcanvas-title" id="offcanvasExampleLabel">
                                            KIRANA
                                        </h5> */}
                                    </div>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="offcanvas"
                                        aria-label="Close"
                                    ></button>
                                </div>
                                <div className="offcanvas-body">
                                    <div className={style.navlink_dashboard}>
                                        <ul>
                                            <li><NavLink className={style.navdash_link} to="/Dashboard_panel/billing_panel" onClick={closeOffcanvas}> <i className="fa-solid fa-file-invoice-dollar me-2"></i> Billing Panel</NavLink></li>
                                            <li><NavLink className={style.navdash_link} to="/Dashboard_panel/inventory_panel" onClick={closeOffcanvas}> <i className="fa-solid fa-boxes me-2"></i> Inventory</NavLink></li>
                                            <li><NavLink className={style.navdash_link} to="/Dashboard_panel/customers_panel" onClick={closeOffcanvas}> <i className="fa-solid fa-users me-2"></i> Customer Management</NavLink></li>
                                            <li><NavLink className={style.navdash_link} to="/Dashboard_panel/suppliers_panel" onClick={closeOffcanvas}> <i className="fa-solid fa-truck me-2"></i> Supplier Management</NavLink></li>
                                            {/* <li><NavLink className={style.navdash_link} to="/Dashboard_panel/account_panel" onClick={closeOffcanvas}> <i className="fa-solid fa-user-cog me-2"></i> Account Management </NavLink></li> */}
                                            {/* <li><NavLink className={style.navdash_link} to="/Dashboard_panel/Admin_panel" onClick={closeOffcanvas}> <i className="fa-solid fa-user-shield me-2"></i> Admin</NavLink></li> */}
                                            <li><NavLink className={style.navdash_link} to="/Dashboard_panel/Setting_panel" onClick={closeOffcanvas}> <i className="fa-solid fa-cogs me-2"></i> Setting</NavLink></li> 
                                            <button className={style.logoutbtn} onClick={() => { handleLogout(); closeOffcanvas(); }}>
                                                <i class="fa-solid fa-right-from-bracket"></i>  Logout
                                            </button>
                                        </ul>
                                    </div>
                                </div>
                                {/* </div> */}
                            </div>


                        </div>
                    </div>
                </nav>
            </div>


        </>
    );
};

export default DashboardNavbar;
